import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";

// Landing Page Components
import BoldHeader from "./components/BoldHeader";
import BoldHero from "./components/BoldHero";
import MotivationMarquee from "./components/MotivationMarquee";
import DynamicAppShowcase from "./components/DynamicAppShowcase";
import PowerFeatures from "./components/PowerFeatures";
import BoldTestimonials from "./components/BoldTestimonials";
import AggressivePricing from "./components/AggressivePricing";
import FinalCTA from "./components/FinalCTA";
import BoldFooter from "./components/BoldFooter";

// App Components
import LoginPage from "./components/LoginPage";
import RegisterPage from "./components/RegisterPage";
import Dashboard from "./components/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";

// Landing Page Component
const LandingPage = () => {
  return (
    <div className="App">
      <BoldHeader />
      <main>
        <section id="home">
          <BoldHero />
        </section>
        <MotivationMarquee />
        <section id="app">
          <DynamicAppShowcase />
        </section>
        <section id="why">
          <PowerFeatures />
        </section>
        <section id="stories">
          <BoldTestimonials />
        </section>
        <section id="pricing">
          <AggressivePricing />
        </section>
      </main>
      <FinalCTA />
      <BoldFooter />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } 
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;